// Utils & misc
import cn from '../../../utils/cn';

// Style
import styles from './FormTab.module.css';

/**
 *
 * @param {object} params
 * @param {React.ReactNode} params.children
 * @param {string} [params.className]
 * @param {string} params.role
 * @param {boolean} params.ariaSelected
 * @param {string} params.ariaControls
 * @param {(event: React.MouseEvent<HTMLButtonElement>) => void} params.onClick
 * @param {boolean} params.disabled
 * @param {boolean} params.isActive
 * @returns {JSX.Element}
 */
function FormTab({
  children,
  className,
  role = 'tab',
  ariaSelected = false,
  ariaControls = '',
  onClick,
  disabled = false,
  isActive = false,
}) {
  return (
    <button
      type="button"
      role={role}
      aria-selected={ariaSelected}
      aria-controls={ariaControls}
      onClick={onClick}
      disabled={disabled}
      className={cn([styles['form-tab'], isActive && styles['form-tab-active'], className])}
    >
      {children}
    </button>
  );
}

export default FormTab;
